import {
  offset,
  useDismiss,
  useFloating,
  useInteractions
} from '@floating-ui/react'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'
import { Checkbox } from '~/components/Form'
import type { ApplicantHeadData } from '~/domains/applicants/types'
import type { StorageObject } from '~/domains/attachments/types'
import {
  attachmentsContainer,
  attachmentsContainerTitle,
  attachmentsSelectorDropdown,
  attachmentsSelectorDropdownSection,
  attachmentsSelectorDropdownSectionItem,
  attachmentsSelectorDropdownSectionTitle,
  attachmentsSelectorTrigger
} from '../Actions.css'

type EmailApplicantAttachmentsSelectorProps = {
  applicantDataHead: (ApplicantHeadData & {
    attachments?: { id: number; object: StorageObject }[]
  })[]
  setAttachmentsIds: React.Dispatch<React.SetStateAction<number[]>>
  attachmentsIds: number[]
}

export const EmailApplicantAttachmentsSelector = ({
  applicantDataHead,
  setAttachmentsIds,
  attachmentsIds
}: EmailApplicantAttachmentsSelectorProps) => {
  const [openAttachments, setOpenAttachments] = useState(false)
  const {
    refs: attachmentsRefs,
    floatingStyles: attachmentsStyles,
    context: contextAttachments
  } = useFloating({
    open: openAttachments,
    onOpenChange: setOpenAttachments,
    placement: 'bottom-end',
    middleware: [offset(10)]
  })
  const dismiss = useDismiss(contextAttachments)
  const { getReferenceProps, getFloatingProps } = useInteractions([dismiss])

  return (
    <div className={attachmentsContainer}>
      <div className={attachmentsContainerTitle}>
        {applicantDataHead.length === 1
          ? `${applicantDataHead?.[0]?.firstname} ${applicantDataHead?.[0]?.lastname}`
          : `${applicantDataHead?.length} candidats`}
      </div>
      <div
        ref={attachmentsRefs.setReference}
        onClick={() => setOpenAttachments(!openAttachments)}
        className={attachmentsSelectorTrigger}
        {...getReferenceProps()}
      >
        <span>
          <strong>{attachmentsIds.length}</strong> document
          {attachmentsIds.length > 1 ? 's' : ''} sélectionné
          {attachmentsIds.length > 1 ? 's' : ''}
        </span>
        <FontAwesomeIcon icon={faChevronDown} />
      </div>
      {openAttachments && (
        <div
          ref={attachmentsRefs.setFloating}
          style={attachmentsStyles}
          className={attachmentsSelectorDropdown}
          {...getFloatingProps()}
        >
          {applicantDataHead?.map((applicant) => (
            <div
              key={applicant.id}
              className={attachmentsSelectorDropdownSection}
            >
              <div className={attachmentsSelectorDropdownSectionTitle}>
                {applicant.firstname} {applicant.lastname}
              </div>
              {applicant.attachments?.map((attachment) => (
                <div
                  key={attachment.id}
                  className={attachmentsSelectorDropdownSectionItem}
                >
                  <Checkbox
                    defaultChecked={attachmentsIds.includes(attachment.id)}
                    onChange={(checked) => {
                      setAttachmentsIds((prev: number[]) =>
                        checked
                          ? [...prev, attachment.id]
                          : prev.filter((id) => id !== attachment.id)
                      )
                    }}
                    label={attachment.object.filename}
                  />
                </div>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
